import { z } from 'zod';
import { uuidV7Schema } from './ids';

export const readinessAreaSchema = z.enum([
  'configuration',
  'subscription',
  'sources',
  'email',
  'calendar',
  'quality',
  'handoff',
]);
export const readinessReportSchema = z
  .object({
    checkedAt: z.iso.datetime({ offset: true }),
    releaseId: uuidV7Schema.nullable(),
    checks: z
      .array(
        z
          .object({
            area: readinessAreaSchema,
            resource: z.string().nullable(),
            status: z.enum(['passed', 'blocked', 'review', 'disabled']),
            code: z.string(),
          })
          .strict()
      )
      .max(60),
  })
  .strict();
export type ReadinessReport = z.infer<typeof readinessReportSchema>;
export type ReadinessCheck = ReadinessReport['checks'][number];
